import React, { useEffect } from "react";
import AnimateLine from "../../common/AnimateLine";
import Breadcrumb from "../../common/Breadcrumb";
import ProjectDetail1 from "./Project-1";
import ProjectDetail2 from "./Project-2";
import ProjectDetail3 from "./Project-3";
// import ProjectDetail4 from "./Project-4";
import ProjectDetail14 from "./project-14";
import ProjectDetail15 from "./Project-15";

import data from '../../../data/data'
import { useState } from "react";

function ProjectDetails(props) {
  const { match } = props
  const [projectDetail, setProjectDetail] = useState({})

  const renderComponent = () => {
    switch (match.params.id) {
      case "1":
        return <ProjectDetail1 projectDetail={projectDetail} />;
      case "2":
        return <ProjectDetail2 projectDetail={projectDetail} />;
      case "3":
        return <ProjectDetail3 projectDetail={projectDetail} />;
      // case "4":
      //   return <ProjectDetail4 projectDetail={projectDetail} />;
      case "14":
        return <ProjectDetail14 projectDetail={projectDetail} />;
      case "15":
        return <ProjectDetail15 projectDetail={projectDetail} />;
      default:
        return null;
    }
  }


  useEffect(() => {
    setProjectDetail(data.filter((item) => item.id === match.params.id)[0])
  }, [match.params.id])
  return (
    <>
      <div className="creasoft-wrap">
        <AnimateLine />
        <Breadcrumb pageName="Project Details" pageTitle="Project Details" />
        {renderComponent()}
      </div>
    </>
  );
}

export default ProjectDetails;
